/** Internal model labels retain their abbreviations; visible names are localized once. */
export function pmcSeriesLabel(label: string, translate: (key: string) => string): string {
  const key = label.includes('CTL') ? 'fitness' : label.includes('ATL') ? 'fatigue'
    : label.includes('TSB') ? 'battery' : label === 'TSS' ? 'load' : null;
  return key ? translate(`charts.pmcSeries.${key}`) : label;
}
